import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { ForumTopic } from '../../../../models/forumTopic';
import { approveTopic } from '../../../../service/forumTopic';
import { getUser } from '../../../../service/user';
import { getClubNameByPathname } from '../../../../utils/club';
import Button from '../../../../components/Button/Button'
import { createSuccessNotification, createErrorNotification } from '../../../../service/notification';
import { formatDate } from '../../../../utils/date';


import styles from './TopicItem.module.scss';

interface PropsForumTopic {
  forumTopic: ForumTopic;
  forumId: number;
  clubId: number;
  isAdminOrMediator: boolean;
  isCreatorUser: boolean;
}

type Props = Pick< PropsForumTopic, 'forumTopic' | 'forumId' | 'clubId' | 'isAdminOrMediator' | 'isCreatorUser'> 
& {
  refetchData: () => void
};

const ForumTopicItem = ({ forumTopic, forumId, clubId, isAdminOrMediator, isCreatorUser, refetchData }: Props) => {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const formattedDate = formatDate(forumTopic.createdAt);
  const userId = forumTopic.creatorUserId;

  const onFinish = async () => {
    if(loading) return;

    setLoading(true);

    await approveTopic(clubId, forumId, forumTopic.id)
    setLoading(false);
      
    createSuccessNotification('Tópico do fórum aprovado!');

    refetchData();
  }

  const openForumTopic = async () => {
    if(forumTopic.wasApproved){
      const clubName = getClubNameByPathname();
      navigate(`/club/${clubId}/${clubName}/forum/${forumId}/topic/${forumTopic.id}`);
    } else {
      createErrorNotification('É necessário que o tópico do fórum de discussão seja aprovado!')
    }
  }

  const {data:user} = useQuery(
    ['topic', 'user', userId],
    () => getUser(userId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  return (
  
    <div className={styles.forumTopic} key={"topic_"+forumTopic.id}>
      <h3 className={styles.title} onClick={openForumTopic}>
        {forumTopic.title}
      </h3>
      <p className={styles.description}>{forumTopic.description}</p>
      <div className={styles.creator}>
        <div onClick={() => navigate(`/user/${user.id}`)}>
          <i>Criado por <strong className={styles.user}>{user?.fullname}</strong></i>
        </div>
        <div>{formattedDate}</div>
      </div>
      <div className={styles.blocks}>
        <div></div>
        <div></div>
        <div className={styles.buttonField}>
          {isAdminOrMediator && !forumTopic.wasApproved && (
            <Button style={styles.approveButton} onClick={onFinish}>
              Aprovar tópico
            </Button>
          )}
          {(!isAdminOrMediator) && (!forumTopic.wasApproved) && (isCreatorUser) && (
            <Button style={styles.waitingButton} disabled>
              Aguardando aprovação
            </Button>
          )}
        </div>
      </div>
      
    </div>
  )
}

export default ForumTopicItem;